export default "__VITE_ASSET__5N8TiHsi__"